import React from 'react';
import './FloatNavigation.scss';
import Draggable from 'react-draggable';

class FloatNavigation extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			openType: true,
			activeDrags: 0,
			panning: false
		}
	}

	handlePreventTouchmoveWhenPanning = (event) => {
		if (this.state.panning) {
			event.preventDefault();
		}
	};

	componentDidMount() {
		window.document.body.addEventListener('touchmove', this.handlePreventTouchmoveWhenPanning, {
			passive: false
		})
	}

	componentWillUnmount() {
		window.document.body.removeEventListener('touchmove', this.handlePreventTouchmoveWhenPanning, {
			passive: false
		})
	}

	toggleState() {
		this.setState({
			openType: !this.state.openType
		})
	}

	onStart() {
		this.setState({
			panning: true
		});
	}

	onStop() {
		this.setState({
			panning: false
		});
	}

	linkUrl() {
		this.props.toggleOrder && this.props.toggleOrder()
	}

	render() {
		const dragHandlers = {
			axis: 'y',
			bounds: this.props.bounds || '.index-container',
			onStart: () => this.onStart(),
			onStop: () => this.onStop()
		};

		const floatReward = require('../../asstes/img/Index/index-float-icon.png')

		return (
			<Draggable {...dragHandlers}>
				<div className="index-float-navigation-container"
				     onClick={() => this.linkUrl()}>
					<img src={floatReward} alt=""/>
				</div>
			</Draggable>
		);
	}
}

export default FloatNavigation;
